<template>
  <div>
    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="CUSTOMER USERS" v-can:any="['view-user', 'create-user', 'edit-user']">
          <template slot="actions">
            <vs-button v-can="'create-user'" @click="onClickCreateUser" class="mr-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input v-can="'view-user'" icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table v-can="'view-user'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"  @sort="handleSort"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th width="15%" sort-key="first_name">FIRST NAME</vs-th>
                <vs-th width="15%" sort-key="last_name">LAST NAME</vs-th>
                <vs-th width="15%" sort-key="email">EMAIL</vs-th>
                <vs-th width="15%">LAST LOGGED</vs-th>
                <vs-th width="10%">ROLE</vs-th>
                <vs-th width="15%">PORTAL STATUS</vs-th>
                <vs-th width="15%" v-can="'edit-user'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].first_name">
                    {{ data[indextr].title ? data[indextr].title : '' }} {{ data[indextr].first_name }}
                  </vs-td>
                  <vs-td :data="data[indextr].last_name">
                    {{ data[indextr].last_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].last_login_at">
                    {{ __dateTimeFormatter(data[indextr].last_login_at) }}
                  </vs-td>

                  <vs-td :data="data[indextr].role.name">
                    {{ data[indextr].role ? data[indextr].role.name : '-' }}
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip style="border-radius: 0;" transparent :color="userListStatusColorFactory(data[indextr].status.id)">
                      {{data[indextr].status.name}}
                    </vs-chip>
                  </vs-td>


                  <vs-td v-can="'edit-user'">
                    <div class="vx-row">
                      <vx-tooltip text="View" position="left">
                        <vs-button @click.native="onClickSupplierUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="!data[indextr].email_verified_at" text="Resend welcome email" position="left">
                        <vs-button class="ml-3" @click.native="onClickSupplierEmailResend(data[indextr].email)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-rotate-ccw "></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="data[indextr].status.id === 3 && data[indextr].email !== currentUser.email" text="De-Activate user" position="left">
                        <vs-button class="ml-3" size="small" @click="openStatusChangeConfirm(data[indextr].id, 'de-activate')"
                                   color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Activate user" position="left">
                        <vs-button @click="openStatusChangeConfirm(data[indextr].id, 'activate')"
                                   v-if="data[indextr].status.id === 4 && data[indextr].email !== currentUser.email" class="ml-3" size="small"
                                   color="primary" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination v-can="'view-user'" :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-supplier-pop-up ref="createSupplierPopUp"/>
    <update-supplier-pop-up ref="updateSupplierPopUp"/>
    <view-supplier-pop-up ref="viewSupplierPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const SupplierRepository = RepositoryFactory.get('supplier')
  import CreateSupplierPopUp from '@/components/popups/supplier/CreateSupplierPopUp'
  import UpdateSupplierPopUp from '@/components/popups/supplier/UpdateSupplierPopUp'
  import ViewSupplierPopUp from '@/components/popups/supplier/ViewSupplierPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import store from "../../../store/store";


  export default {
    name: 'AllUsersList',
    data () {
      return {
        selected: [],
        updateStaffSelected: [],
        options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
        popupActive: false,
        createUserPopupActive: false,
        popUpTitle: '',
        editActive: false,
        edit: null,
        editProp: {},
        checkBox1: false,
        activeConfirm: false,
        staff: [],
        selectedStaff: {},
        createStaffForm: {},
        departments: [],
        users: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        currentUser: {}
      }
    },
    components: {
      'v-select': vSelect,
      CreateSupplierPopUp,
      UpdateSupplierPopUp,
      ViewSupplierPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.currentUser = store.getters.currentUser
      console.log(this.currentUser)
      // this.$refs.filterCard.isContentCollapsed = false
      // this.$refs.filterCard.maxHeight = '1.5rem'

      // this.$vs.loading()
      // this.loadStaff()
      // this.$vs.loading.close()

    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },

      async loadStaff() {
        this.$vs.loading()
        const {data} = await SupplierRepository.get(this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        console.log(this.staff)
        this.$vs.loading.close()
      },
      openConfirm () {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remove Confirm',
          text: 'Are you sure you want to permanently remove this organization?',
          accept: this.acceptAlert
        })
      },

      acceptAlert () {
        this.$vs.notify({
          color: 'danger',
          title: 'Deleted Organization',
          position:'top-right',
          text: 'The selected organization was successfully deleted'
        })
      },
      openStatusChangeConfirm (id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: status === 'activate' ? 'success' : 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.changeUserStatus,
          parameters: [id, status]
        })
      },
      async changeUserStatus (params) {
        console.log(params)
        this.$vs.loading()
        try {
          await SupplierRepository.changeCustomerUserStatus(params[0], params[1])
          this.showSuccessMessage('Customer user status updated!')
          await this.loadStaff()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreateUser () {
        await this.$refs.createSupplierPopUp.openPopup()
      },
      async onClickSupplierUpdate (id) {
        await this.$refs.updateSupplierPopUp.openPopup(id)
      },
      async onClickSupplierEmailResend (email) {
        this.$vs.loading()
        try {
          const {data} = await SupplierRepository.customerUserWelcomeEmailResend(email)
          this.showSuccessMessage('Email resend successfully!')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickSupplierView (id) {
        await this.$refs.viewSupplierPopUp.openPopup(id)
      },
      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }

      },
      userListStatusColorFactory(status_id) {
        switch (status_id) {
          case 1:
            return 'dark';
          case 2:
            return 'warning';
          case 3:
            return 'primary';
          case 4:
            return 'danger';
        }
      },

    },
    watch : {
      page(){
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
